import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    rowContainer: {
      flex: 1,
      marginRight: "0px",
      marginTop: "20px",

      [theme.breakpoints.up("md")]: {
        marginTop: 0,
      },
    },
    autocompleteHint: {
      color: theme.gray400,
      fontSize: "12px",
      marginLeft: "14px",
      marginTop: "3px",
      overflowX: "auto",
    },
    givePointsTextInput: {
      backgroundColor: theme.white50,
      width: "100%",
    },
  }),
);
